'use client'

import * as React from 'react'

import type { useComments } from '../_hooks/use-project-comments'
import type { Project } from '../page-client'
import { ProjectComment } from './project-comment'
import { SkeletonItem } from 'components/skeleton-item'
import { Button } from '@repo/design-system-cf/components/button'

export function ProjectComments({
  project,
  commentsData,
  onBumpCommentsCount,
  onDecrementCommentsCount,
}: {
  project: Project
  commentsData: ReturnType<typeof useComments>
  onBumpCommentsCount?: () => void
  onDecrementCommentsCount?: () => void
}) {
  const { comments, isLoading, isFetchingNextPage, refetch, hasNextPage, handleLoadMore } =
    commentsData

  const isInitialLoading = isLoading && comments.length === 0

  if (isInitialLoading) {
    return (
      <div className="flex gap-2 pt-[10px]">
        <SkeletonItem className="size-8 rounded-full mt-5" />
        <SkeletonItem className="w-full h-20" />
      </div>
    )
  }

  return (
    <>
      {comments.map(comment => (
        <ProjectComment
          key={comment.id}
          comment={comment}
          projectData={project}
          onCommentUpdate={refetch}
          onBumpCommentsCount={onBumpCommentsCount}
          onDecrementCommentsCount={onDecrementCommentsCount}
        />
      ))}

      {hasNextPage ? (
        <div className="mt-3 flex justify-center">
          <Button
            onClick={handleLoadMore}
            variant="tertiary"
            className="w-full"
            loading={isFetchingNextPage}
          >
            Load more comments
          </Button>
        </div>
      ) : null}
    </>
  )
}
